import ReactEcharts from "echarts-for-react";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
// import { SVGRenderer } from "echarts/renderers";
// import * as echarts from "echarts/core";

const useStyles = makeStyles((theme) => ({
  singleValueContainer: {
    width: "100%",
  },
  titleContainer: {
    fontSize: "18px",
    color: "#464646",
    fontWeight: "bold",
    fontFamily: "sans-serif",
    textAlign: "left",
  },
  finalValue: {
    fontSize: "80px",
    color: "#5d5d5d",
    display: "flex",
    height: "250px !important",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function RenderChart({ option, onLoadCallback }) {
  // echarts.use([SVGRenderer]);
  const echartRef = React.useRef(null);
  const [graphDataBase64, setGraphDataBase64] = React.useState("");

  // @Todo(Raj): Somehow the chart blinks after a bit (maybe because of the setGraphBase64 in the onloadCallback of AnalyticsChart.jsx)
  //             Simplify this and cleanup.

  return (
    <ReactEcharts
      ref={echartRef}
      notMerge={true}
      lazyUpdate={true}
      onEvents={{
        click: (params) => {},
        finished: () => {
          if (echartRef.current && !graphDataBase64) {
            let base64 = echartRef.current.getEchartsInstance().getDataURL({
              backgroundColor: "white",
            });

            onLoadCallback(base64);
            setGraphDataBase64(base64);
          }
        },
      }}
      option={option}
      style={{ width: "100%", height: "380px" }}
      // opts={{ renderer: "svg" }}
    />
  );
}

function singleValueSuffix(dataType) {
  switch (dataType) {
    case "counts":
      return "";
    case "percentage":
      return "%";
    case "days":
      return " days";
    default:
      return "";
  }
}

function ReczeeChart({ chartTitle, data, dataType, onLoadCallback }) {
  const classes = useStyles();
  if (typeof data === "number") {
    return (
      <div className={classes.singleValueContainer}>
        <div className={classes.titleContainer}>{chartTitle}</div>
        <div className={classes.finalValue}>
          {data === -1 ? (
            "-"
          ) : (
            <>
              {data}
              {singleValueSuffix(dataType)}
            </>
          )}
        </div>
      </div>
    );
  } else {
    return <RenderChart option={data} onLoadCallback={onLoadCallback} />;
  }
}

export default React.memo(ReczeeChart);
